import { Fragment } from 'react'

import PanelMobileMenu from '~/panels/components/PanelMobileMenu'
import TutorOnDemandProductCards from '~/shared/components/TutorOnDemandProductCards/TutorOnDemandProductCards.component'
import Spinner from '~/components/Spinner'
import { STUDENT_PANEL_TABS } from '~/panels/constants/student-panel'
import { useGetStudentExistsQuery } from '~/redux/apis/student-api'
import appConfig from '~/config/app'
import { useAppSelector } from '~/redux/hooks'
import { isAuthenticated } from '~/auth/slices/auth.slice'

export default function Student({ isMobile }: { isMobile: boolean }): React.ReactElement {
  const authenticated = useAppSelector(isAuthenticated)
  const { data: isStudentExists, isLoading } = useGetStudentExistsQuery(undefined, { skip: !authenticated })

  if (!isStudentExists && !isLoading && !appConfig.isMobileApp) {
    return (
      <TutorOnDemandProductCards
        className="pt-12 max-w-max mx-auto space-y-14 lg:space-y-0 lg:space-x-4 xl:space-x-8 flex flex-col lg:flex-row"
        colorScheme="white"
        hideChatWithTutor
        hideVideoChatWithTutor
      />
    )
  } else if (isMobile) {
    return <PanelMobileMenu tabs={STUDENT_PANEL_TABS} />
  } else if (!appConfig.isMobileApp) {
    return <Spinner color="purple" />
  }
  return <Fragment />
}
